<template>
  <div
    class="carChart"
    id="line-chart"
    :style="{ width: width + 'px', height: height + 'px' }"
  ></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "line-chart",
  props: {
    volume_data: Array,
    time_type: String,
    series_name: String,
    width: Number,
    height: Number,
    is_loading: Boolean
  },
  data() {
    return {
      chart: {},
    };
  },
  watch: {
    volume_data(new_val) {
      this.chart.showLoading();
      this.volume_data = new_val;
      this.draw();
    },
    is_loading(new_val)
    {
      new_val ? this.chart.showLoading() : this.chart.hideLoading();
    }
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("line-chart"));
    this.chart.showLoading();
  },
  computed: {},
  methods: {
    draw() {
      const _this = this;
      const data = _this.volume_data;
      if (null == data || "undefined" == typeof data || "" == data) {
        this.chart.hideLoading();
        this.chart.setOption({xAxis: {type: 'category',data: ['暂无数据']},yAxis: {type: 'value'}}, true);
        return;
      }
      var option = {};
      if (Object.keys(data).length !== 0) {
        let xAxisData = [];
        let typeData = [];
        let seriesData = [];
        // var yoy_seriesData = [];
        // var mom_seriesData = [];

        xAxisData = Array.from(
          new Set(
            data.map(function (x) {
              return x.date;
            })
          )
        );

        typeData = Array.from(
          new Set(
            data.map(function (x) {
              return x.project;
            })
          )
        );

        var xAxisName;
        switch (_this.time_type) {
          case "year":
            xAxisName = "（年）";
            break;
          case "quarter":
            xAxisName = "（季度）";
            break;
          case "month":
            xAxisName = "（月）";
            break;
        }

        for (let i in typeData) {
          var volume = [];
          data.forEach(function (item) {
            if (item.project === typeData[i]) {
              volume.push(item.volume);
            }
          });
          seriesData.push({
            name: typeData[i],
            type: "line",
            data: volume,
            smooth: true
          });
        }

        // for (let i in _this.volume_data.times) {
        //   xAxisData.push(_this.volume_data.times[i]);
        //   var result = _this.volume_data.chart.filter(function (item) {
        //     switch (_this.time_type) {
        //       case "year":
        //         xAxisName = "（年）";
        //         return item.yearDate == _this.volume_data.times[i];
        //       case "quarter":
        //         xAxisName = "（季度）";
        //         return (
        //           item.yearDate + "-" + item.interval ==
        //           _this.volume_data.times[i]
        //         );
        //       case "month":
        //         xAxisName = "（月）";
        //         return item.date == _this.volume_data.times[i];
        //     }
        //   });
        //   var num = 0;
        //   result.forEach(function (item) {
        //     num += item.volume;
        //   }, 0);
        //   seriesData.push(num);
        //   // yoy_seriesData.push(result[0].yoY)
        //   // mom_seriesData.push(result[0].moM)
        // }
        // 指定图表的配置项和数据
        option = {
          // color: ["#00578F"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line", // 默认为直线，可选为：'line' | 'shadow'
            },
            confine: true,
            formatter: (params) => {
            let list = [];
            if(params && params.length > 0)
            {
              list.push('<span style="font-size:12px;color:#6e7079;margin-left:2px">' + params[0]?.name + '</span><div style="clear:both"></div>')
            }
            let listItem = "";
            for (let param of params) {
              list.push(
                param.marker +
                  '<span style="font-size:12px;color:#6e7079;margin-left:2px;">' +
                    param.seriesName
                  +
                  '</span>' +
                  '<span style="float:right;font-size:12px;margin-left:20px;">' +
                    param.value.toLocaleString() +
                  "</span>" +
                  '<div style="clear:both"></div>'
              );
            }
            listItem = list.join("");
            return listItem;
          },
            //   formatter: (params) => {
            //   let list = [];
            //   if(params&&params.length > 0)
            //   {
            //     list.push('<span style="font-size:12px;color:#6e7079;margin-left:2px">' + params[0]?.name + '</span><div style="clear:both"></div>')
            //   }
            //   let listItem = "";
            //   for (let param of params) {
            //       list.push(
            //         param.marker +
            //           '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
            //           param.seriesName +
            //           "</span>：" +
            //           '<span style="font-size:12px;margin-left:5px;">' +
            //             param.value.toLocaleString() +
            //           "</span>" +
            //           '<div style="clear:both"></div>'
            //       );
            //       list.push(
            //         param.marker +
            //           '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
            //           '环比' +
            //           "</span>：" +
            //           '<span style="font-size:12px;margin-left:5px;color:' + (Number(mom_seriesData[param.dataIndex].replace('%','')) > 0 ? 'green' : 'red') +';">' +
            //             mom_seriesData[param.dataIndex] +
            //           "</span>" +
            //           '<div style="clear:both"></div>'
            //       );
            //       list.push(
            //         param.marker +
            //           '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
            //           '同比' +
            //           "</span>：" +
            //           '<span style="font-size:12px;margin-left:5px;color:' + (Number(yoy_seriesData[param.dataIndex].replace('%','')) > 0 ? 'green' : 'red') + ';">' +
            //             yoy_seriesData[param.dataIndex] +
            //           "</span>" +
            //           '<div style="clear:both"></div>'
            //       );
            //   }

            //   listItem = list.join("");
            //   return listItem;
            // },
          },
          legend: {
            type: "scroll",
            icon: "circle",
            bottom: 1,
            left: "center",
            padding: [20, 52, 20, 52],
          },
          yAxis: [
            {
              type: "value",
              name: "（辆）",
            },
          ],
          xAxis: {
            data: xAxisData,
            name: xAxisName,
          },
          series: seriesData
          // series: {
          //   name: this.series_name,
          //   type: "line",
          //   smooth: true,
          //   data: seriesData,
          //   areaStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //       {
          //         offset: 0,
          //         color: "#c9defd ",
          //       },
          //       {
          //         offset: 1,
          //         color: "#ffffff",
          //       },
          //     ]),
          //   },
          // },
        };
      }
      
      this.chart.clear();
      this.chart.setOption(option, true);
      this.chart.hideLoading();
    },
  },
};
</script>
